module.exports = __webpack_public_path__ + "images/Singer.7233f5a5997a100883472bac04ffa3b1.svg";